export class UiActionButton {
    constructor(options: UiActionButton) {
        Object.assign(this, options);
    }
    public name: string;
    public key: string;
    public fn?: Function = () => { };
    public visible?: boolean = false;
    public order?: number = 100;
    public triggersSubmit?: boolean = true;
    public redirectAfterSubmit?: boolean = true;
    public children?: UiActionButton[] = [];
    public performValidation?: boolean = true;
}